import type {representativeNotesRouteApi} from "./-route-api";

import {tableURLStateSchema} from "@project/components/data-display/table";
import {z} from "zod";

export const representativeNotesSearchSchema = tableURLStateSchema.extend({
  includeDeleted: z.boolean().optional().default(false),
});

export type RepresentativeNotesSearch = z.output<typeof representativeNotesSearchSchema>;
export type RepresentativeNotesNavigateFn = ReturnType<
  typeof representativeNotesRouteApi.useNavigate
>;
